module.exports = __webpack_public_path__ + "fonts/SpaceGrotesk-Bold.84491a7.otf";